<template>
  <div>
    <!-- Beam part, main -->
    <div
      :style="{
        position: 'relative',
        background:
          index == 0
            ? 'transparent'
            : impactProtectorColor,
        width: '100%',
        height: mmToEm(sector.beam.height)
      }"
    />

    <div
      v-if="index > 0"
      style="position: relative"
    >
      <!-- Beam part, left bracket -->
      <div
        :style="{
          position: 'absolute',
          left: mmToEm(0),
          width: mmToEm(40),
          top: mmToEm(-sector.beam.height - 55),
          height: mmToEm(240),
          borderTopLeftRadius: mmToEm(40),
          borderBottomLeftRadius: mmToEm(40),
          background: beamColor,
          zIndex: 1001
        }"
      />
      <!-- Beam part, right bracket -->
      <div
        :style="{
          position: 'absolute',
          left: mmToEm(sector.beam.length + 20),
          width: mmToEm(40),
          top: mmToEm(-sector.beam.height - 55),
          height: mmToEm(240),
          borderTopRightRadius: mmToEm(40),
          borderBottomRightRadius: mmToEm(40),
          background: beamColor,
          zIndex: 1001
        }"
      />
    </div>

    <div
      class="pallet-level"
      :style="{
        left: mmToEm(30),
        width: mmToEm(sector.beam.length)
      }"
    >
      <!-- Pallet -->
      <template v-for="pallet in sector.beam.pallets">
        <div
          :key="`${index}:${pallet}`"
          class="pallet-level-pallet"
          :style="{
            borderSize: 'border-box',
            width: mmToEm(800),
            marginTop: mmToEm(-levelDistance + 100),
            height: mmToEm(levelDistance - (sector.beam.height + 200)),
            backgroundColor: '#fce2c9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative'
          }"
        >
          <!-- Pallet part, floor -->
          <div
            :style="{
              position: 'absolute',
              left: 0,
              top: mmToEm(levelDistance - (sector.beam.height + 250)),
              backgroundColor: '#cea47d',
              height: mmToEm(50),
              width: mmToEm(800),
              zIndex: '1001'
            }"
          />

          <!-- Pallet part, left -->
          <div
            :style="{
              position: 'absolute',
              left: 0,
              top: mmToEm(levelDistance - (sector.beam.height + 200)),
              backgroundColor: '#cea47d',
              height: mmToEm(100),
              width: mmToEm(100),
              zIndex: '1001'
            }"
          />

          <!-- Pallet part, middle -->
          <div
            :style="{
              position: 'absolute',
              left: mmToEm(325),
              top: mmToEm(levelDistance - (sector.beam.height + 200)),
              backgroundColor: '#cea47d',
              height: mmToEm(100),
              width: mmToEm(150),
              zIndex: '1001'
            }"
          />

          <!-- Pallet part, right -->
          <div
            :style="{
              position: 'absolute',
              left: mmToEm(700),
              top: mmToEm(levelDistance - (sector.beam.height + 200)),
              backgroundColor: '#cea47d',
              height: mmToEm(100),
              width: mmToEm(100),
              zIndex: '1001'
            }"
          />

          <!-- Max capacity text -->
          <div
            :style="{
              fontSize: '0.17em',
              display: 'flex',
              justifyContent: 'center',
              lineHeight: 1,
              textAlign: 'center',
              zIndex: '1001'
            }"
          >
            <div v-if="index">
              <template
                v-if="loadCapacityPerPosition === sector.beam.loadCapacity"
              >
                <div
                  style="wrap-mode: nowrap"
                  data-cy="allowed-load-capacity"
                >
                  {{ loadCapacityPerPosition }} kg
                </div>
              </template>
              <template v-else>
                <div
                  style="wrap-mode: nowrap"
                  data-cy="allowed-load-capacity"
                >
                  {{ loadCapacityPerPosition }} kg
                </div>
                <div
                  style="opacity: 0.5; font-size: 0.8em; text-decoration: line-through;"
                  data-cy="max-load-capacity"
                >
                  {{ sector.beam.loadCapacity }} kg
                </div>
              </template>
            </div>
            <div v-else>
              Golvplats
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

let calcLevelDistance = (height, count) => {
  let distance = height / count;
  distance = Math.ceil(distance / 10) * 10; // Make multiples of 10
  return distance;
};

let distributeLevels = (height, levelCount) => {
  let levels = [];
  let levelDistance = calcLevelDistance(height, levelCount);
  for (let y = 0; y < levelCount; y += 1) {
    levels.push(y * levelDistance);
  }
  return levels;
};

export default {
  props: {
    isLeftmost: Boolean,
    isRightmost: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    index: Number,
    // eslint-disable-next-line vue/require-default-prop
    sector: Object
  },
  data() {
    return {
      gableColor: 'linear-gradient(90deg, rgba(201,201,201,1) 0%, rgba(147,147,147,1) 5%, rgba(131,131,131,1) 46%, rgba(112,112,112,1) 50%, rgba(143,143,143,1) 54%, rgba(131,131,131,1) 95%, rgba(75,75,75,1) 100%)',
      impactProtectorColor: 'linear-gradient(180deg, rgba(255,165,165,1) 0%, rgba(255,15,0,1) 3%, rgba(230,15,0,1) 15%, rgba(180,15,0,1) 16%, rgba(253,15,0,1) 97%, rgba(179,15,0,1) 100%)',
      beamColor: 'linear-gradient(180deg, rgba(255,165,165,1) 0%, rgba(230,15,0,1) 3%, rgba(210,15,0,1) 97%, rgba(130,15,0,1) 100%)'
    }
  },
  computed: {
    ...mapState(["selectedUprights", "selectedHeight"]),

    levelDistance() {
      return calcLevelDistance(
        this.selectedHeight,
        Number(this.sector.levelCount) + 1
      );
    },

    levels() {
      return distributeLevels(
        this.selectedHeight,
        Number(this.sector.levelCount) + 1
      );
    },

    loadCapacityPerPosition() {
      return Math.trunc(
        Math.min(
          this.selectedUprights.maxLoad /
            ((this.levels.length - 1) * this.sector.beam.pallets),
          this.sector.beam.loadCapacity
        )
      );
    }
  },
  methods: {
    mmToEm(mm) {
      return mm / 1000 + "em";
    }
  }
};
</script>

<style lang="scss">
.pallet-level {
  position: relative;
  display: flex;
  justify-content: space-evenly;
  -ms-flex-pack: distribute;
  flex-direction: row;
}
</style>
